"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const types_1 = require("@pbl/pbl-react-core/lib/models/survey/pbl/types");
const classnames_1 = require("classnames");
const _ = require("lodash");
const React = require("react");
const CardBody_1 = require("../../card/CardBody");
const hideable_1 = require("../../hideable");
const package_1 = require("../../package");
const SurveyScreenStyle_1 = require("../jss/SurveyScreenStyle");
const SurveyImage_1 = require("../SurveyImage");
const SingleSelectQuestion = ({ questionIndex, classes, question, groupName, answer, onChange, theme, gridView, quizResponse, showSummaryAnswers, quizType }) => {
    const [options] = React.useState(question.options ? _.orderBy(question.options, ['id'], ['asc']) : []);
    const [value, setValue] = React.useState(answer);
    const isCorrect = React.useMemo(() => {
        if (!quizResponse || !value)
            return false;
        return quizResponse.correctAnswers.some(r => r === value.id);
    }, [quizResponse]);
    const applyQuizStyle = React.useMemo(() => Boolean(quizResponse) && Boolean(showSummaryAnswers), [quizResponse, showSummaryAnswers]);
    const setRadioValue = (_event, _value) => {
        setValueString(_value);
    };
    const setDropDownValue = (event) => {
        if (event.target.value) {
            setValueString(event.target.value);
        }
    };
    const setValueString = (strVal) => {
        const optionValue = options.find((option) => option.id.toString() === strVal.toString()) || null;
        setValue(optionValue);
        onChange(question, optionValue);
    };
    const renderDropDown = () => ((0, jsx_runtime_1.jsx)(core_1.FormControl, Object.assign({ className: classes.dropDownRoot }, { children: (0, jsx_runtime_1.jsxs)(core_1.Select, Object.assign({ name: 'answer-' + groupName, value: value && value.optionText ? value.id : '', displayEmpty: true, inputProps: {
                className: classes.selectLabel,
                id: 'Answer-' + groupName,
                ariaLabelledby: 'Answer-' + groupName
            }, onChange: setDropDownValue }, { children: [(0, jsx_runtime_1.jsx)(core_1.MenuItem, Object.assign({ value: "" }, { children: (0, jsx_runtime_1.jsx)("em", { children: "--Select--" }) })), options.map((option) => ((0, jsx_runtime_1.jsx)(core_1.MenuItem, Object.assign({ value: option.id }, { children: _.unescape(option.optionText) }), option.id)))] })) })));
    const renderRadioButton = () => {
        return ((0, jsx_runtime_1.jsx)(core_1.RadioGroup, Object.assign({ id: 'Answer-' + groupName, "aria-label": 'Answer-' + groupName, name: 'answer-' + groupName, value: value && value.optionText ? value.id : '', onChange: setRadioValue }, { children: options.map((option, index) => {
                return renderOptions(index, option);
            }) })));
    };
    const getBorderColor = (correct, selected) => {
        if (correct)
            return theme.palette.success.main;
        if (selected)
            return theme.palette.error.main;
        return theme.palette.grey[500];
    };
    const getBorderColor2 = (correct, incorrect, selected) => {
        if (correct)
            return theme.palette.success.main;
        if (incorrect)
            return theme.palette.error.main;
        if (selected)
            return theme.palette.grey[500];
        return 'transparent';
    };
    const renderOptions = (index, option) => {
        var _a;
        const imageClass = gridView ? classes.optionImageLarge : classes.optionImage;
        let isSelected = option.id === (value === null || value === void 0 ? void 0 : value.id);
        let isOptionCorrect = (_a = quizResponse === null || quizResponse === void 0 ? void 0 : quizResponse.correctAnswers.some(a => a === option.id)) !== null && _a !== void 0 ? _a : false;
        let borderColor = getBorderColor(isOptionCorrect, isSelected);
        if (quizType === 'COMPLETE_ALL_CORRECT') {
            isSelected = option.id === (value === null || value === void 0 ? void 0 : value.id);
            isOptionCorrect =
                (quizResponse === null || quizResponse === void 0 ? void 0 : quizResponse.correctAnswers.some(a => a === option.id)) && (quizResponse === null || quizResponse === void 0 ? void 0 : quizResponse.selectedAnswers.some(a => a === option.id)) ? true : false;
            const isOptionIncorrect = !(quizResponse === null || quizResponse === void 0 ? void 0 : quizResponse.correctAnswers.some(a => a === option.id)) && (quizResponse === null || quizResponse === void 0 ? void 0 : quizResponse.selectedAnswers.some(a => a === option.id)) ? true : false;
            borderColor = getBorderColor2(isOptionCorrect, isOptionIncorrect, isSelected);
        }
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: applyQuizStyle
                ? {
                    border: '3px solid',
                    padding: '5px 10px 0px 15px',
                    marginBottom: '8px',
                    borderColor
                }
                : {} }, { children: [option.imageUrl && (0, jsx_runtime_1.jsx)(SurveyImage_1.default, { imageUrl: option.imageUrl, imageTitle: option.optionText, imageClass: imageClass }), (0, jsx_runtime_1.jsx)(core_1.FormControlLabel, { className: classes.radioContent, value: option.id, id: `answer-${option.optionText}`, control: (0, jsx_runtime_1.jsx)(core_1.Radio, { checked: Boolean(value && (value.optionText || value.imageUrl)) && (value === null || value === void 0 ? void 0 : value.id) === option.id, id: `answer-${option.optionText}`, name: `answer-${groupName}`, className: (0, classnames_1.default)(classes.radioButton, 'radioButton'), color: 'primary' }), label: _.unescape(option.optionText) }, option.id)] }), index));
    };
    const renderQuestionLayout = () => {
        if (question.layout) {
            return question.layout === types_1.Layout.DROPDOWN ? renderDropDown() : renderRadioButton();
        }
        return options.length > 4 ? renderDropDown() : renderRadioButton();
    };
    return ((0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ xs: 12, item: true, style: { paddingBottom: theme.spacing(2) } }, { children: (0, jsx_runtime_1.jsxs)(core_1.Card, Object.assign({ style: { width: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(core_1.CardHeader, { title: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "subtitle1", component: 'span', style: {
                            color: theme.palette.text.primary,
                            paddingTop: theme.spacing(4),
                            paddingBottom: theme.spacing(4),
                            textAlign: 'start'
                        } }, { children: question.questionText })), style: {
                        backgroundColor: theme.palette.grey.A200
                    } }), (0, jsx_runtime_1.jsxs)(CardBody_1.default, { children: [(0, jsx_runtime_1.jsx)(hideable_1.Hideable, Object.assign({ show: Boolean(quizResponse) && Boolean(showSummaryAnswers) }, { children: (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ style: { marginBottom: theme.spacing(1) } }, { children: (0, jsx_runtime_1.jsx)("img", { alt: `Answered ${isCorrect ? 'Correctly' : 'Incorrectly'}`, src: isCorrect ? package_1.assets.internalAssets.correctIcon : package_1.assets.internalAssets.incorrectIcon }) })) })), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ xs: 12, item: true, style: { paddingBottom: theme.spacing(2) } }, { children: renderQuestionLayout() }))] })] })) })));
};
exports.default = (0, core_1.withTheme)((0, core_1.withStyles)(SurveyScreenStyle_1.default)(SingleSelectQuestion));
//# sourceMappingURL=SingleSelectQuestion.js.map